import { createFileRoute } from '@tanstack/react-router'
import Overview from '../../../features/playbook/components/overview/overview'

export const Route = createFileRoute('/_app/playbook/')({
    component: Overview,
})
